module.exports = "d881a6a40b28e7a9a27b960fab7aa534.png";


//////////////////
// WEBPACK FOOTER
// ./assets/sprites/bg7.png
// module id = 77
// module chunks = 0